import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="cta" ref={ref} className="w-full py-20 md:py-28 bg-[#F0EDEB] relative overflow-hidden" data-id="element-14">
      {/* Radial gradient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#722F37]/10 blur-[150px] rounded-full pointer-events-none" data-id="element-15"></div>

      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-6" data-id="element-18">
            Accede a Tu Kit de Rescate
          </h2>

          <div className="bg-[#FFFFFF] rounded-2xl p-8 md:p-10 shadow-2xl border border-[#722F37]/30 mb-8 relative" data-id="element-19">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#8B1A2B] text-white px-6 py-1.5 rounded-full text-sm font-bold shadow-lg flex items-center gap-2 whitespace-nowrap" data-id="element-20">
              <ZapIcon className="w-4 h-4 fill-current" data-id="element-21" />
              OFERTA DE LANZAMIENTO — 40% OFF
            </div>

            <div className="mb-8 mt-4" data-id="element-22">
              <p className="text-[#6B7280] text-lg mb-2" data-id="element-23">Inversión única:</p>
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-24">
                <span className="text-2xl md:text-3xl text-[#8B1A2B] line-through font-medium opacity-80" data-id="element-25">
                  $14.900
                </span>
                <div className="text-5xl md:text-6xl font-bold text-[#722F37]" data-id="element-26">
                  $8.900{' '}
                  <span className="text-2xl font-normal text-[#722F37]/70" data-id="element-27">
                    ARS
                  </span>
                </div>
              </div>
              <p className="text-[#722F37] font-medium text-sm mt-2" data-id="element-28">
                ⚠️ Este precio puede subir en cualquier momento
              </p>
              <p className="text-[#6B7280] italic mt-4" data-id="element-29">
                Menos de lo que cuesta una cena afuera que terminaría en
                discusión
              </p>
            </div>

            <motion.a href="https://clavedepaz.com/cart/44108367659107:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            scale: [1, 1.02, 1],
            boxShadow: ['0 0 0 0 rgba(5, 150, 105, 0)', '0 0 0 15px rgba(5, 150, 105, 0.1)', '0 0 0 0 rgba(5, 150, 105, 0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="w-full bg-[#059669] text-white px-8 py-5 rounded-xl text-xl font-bold shadow-[0_10px_25px_-5px_rgba(5,150,105,0.4)] hover:bg-[#047857] transition-colors flex items-center justify-center gap-3 mb-6" data-id="element-30">
              <DownloadIcon className="w-6 h-6" data-id="element-31" />
              Descargar el producto ahora
            </motion.a>

            {/* Guarantee Box */}
            <div className="bg-white border-2 border-[#059669]/30 rounded-xl p-5 mb-6 flex flex-col items-center text-center gap-2 shadow-sm" data-id="element-32">
              <ShieldCheckIcon className="w-8 h-8 text-[#059669]" data-id="element-33" />
              <h4 className="font-bold text-[#2D2D2D] text-lg" data-id="element-34">
                Garantía de Satisfacción
              </h4>
              <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-35">
                Si el contenido no te aporta valor, tienes 7 días para solicitar
                la devolución total de tu dinero.
              </p>
            </div>

            <div className="flex flex-col gap-3" data-id="element-36">
              <div className="flex items-center justify-center gap-2 text-[#6B7280]" data-id="element-37">
                <ShieldCheckIcon className="w-5 h-5 text-[#722F37]" data-id="element-38" />
                <span className="text-sm font-medium" data-id="element-39">
                  Pago seguro y descarga inmediata en PDF
                </span>
              </div>
              <div className="flex items-center justify-center gap-2 text-[#6B7280] bg-[#F0EDEB] py-2 px-4 rounded-lg border border-black/5 inline-flex mx-auto" data-id="element-40">
                <LockIcon className="w-4 h-4 text-[#722F37]" data-id="element-41" />
                <span className="text-sm font-medium" data-id="element-42">
                  Si no te sirve, te devolvemos tu plata. Sin preguntas.
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}